import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { plurarize, HTML_ENTITY_BULLET, isClip } from 'helpers/ContentHelper';
import { formatRating, formatAiredDate } from 'helpers/VideoHelper';
import { formatMovieMetadata } from '../../HeroHelper';

import style from './TuneIn.module.scss';

const TuneIn = ({ item, episode = {} }) => {
  const {
    contentRating,
    fullEpisodeCount,
    genres = [],
    seasonCount,
    seriesType,
    currentSeason = {},
    subRatings,
  } = item;
  const { originalAirDate, dateCreated, type, durationInSeconds } = episode;

  const genreList = genres.join(', ');
  const rating = formatRating(contentRating);
  let seriesTuneIn;
  const movieMeta = formatMovieMetadata({
    rating,
    subRatings,
    genres: genreList,
    durationInSeconds,
  });
  const originalDate = isClip(type) ? dateCreated : originalAirDate;
  const airDate = formatAiredDate(originalDate);
  const bullet = originalDate ? HTML_ENTITY_BULLET : null;

  if (seasonCount > 0) {
    const { seasonNumber } = currentSeason;

    const {
      seriesDetail_seasonLabel: seasonLabel,
      seriesDetail_seasonsLabel: seasonsLabel,
      global_episodeLabel: foxEpisodeLabel,
      global_episodesLabel: foxEpisodesLabel,
    } = window.Language;

    const seasonText = plurarize({
      count: seasonNumber,
      singular: seasonLabel,
      plural: seasonsLabel,
      reverse: true,
    });
    const episodeText = plurarize({
      count: fullEpisodeCount,
      singular: foxEpisodeLabel,
      plural: foxEpisodesLabel,
    });
    seriesTuneIn = `${seasonText} (${episodeText}) ${HTML_ENTITY_BULLET} ${genreList} ${
      rating ? HTML_ENTITY_BULLET : ''
    } ${rating}`;
  } else if (!_.isEmpty(episode)) {
    seriesTuneIn = airDate ? (
      <div className={style.tuneIn}>{`${airDate} ${rating ? bullet : ''} ${rating}`}</div>
    ) : (
      ''
    );
  }
  let tuneIn;
  switch (seriesType) {
    case 'movie':
    case 'special':
      tuneIn = movieMeta;
      break;
    case 'series':
      tuneIn = seriesTuneIn;
      break;
    default:
      break;
  }

  return tuneIn ? <div className={style.tuneIn}>{tuneIn}</div> : null;
};

TuneIn.propTypes = {
  item: PropTypes.shape({}).isRequired,
  episode: PropTypes.shape({}),
};

export default TuneIn;
